import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=2a84df81&scoped=true"
import script from "./opinion.vue?vue&type=script&lang=js"
export * from "./opinion.vue?vue&type=script&lang=js"
import style0 from "./opinion.vue?vue&type=style&index=0&id=2a84df81&prod&lang=scss&scoped=true"
import style1 from "./opinion.vue?vue&type=style&index=1&id=2a84df81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84df81",
  null
  
)

export default component.exports